const apiUrl = process.env.REACT_APP_BACKEND_HOST;

function buildUpdatePayload(data) {
  if (!data || typeof data !== 'object') {
    return {};
  }
  const payload = { ...data };
  delete payload.id;
  delete payload._id;
  return payload;
}

const cohortSettingsProvider = {
  getOne: async (params) => {
    const url = `${apiUrl}/cohorts/${params.id}/settings`;
    return { url };
  },
  update: async (params) => {
    const url = `${apiUrl}/cohorts/${params.id}/settings`;
    const payload = buildUpdatePayload(params.data);
    const options = {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
    };
    return { url, options };
  },
};
export default cohortSettingsProvider;
